import http from "./http";

export const fetchBrands = async () => {
    const res = await http.get("/brands/get/all", {
        skipGlobalLoader: true
    });
    return res.data;
};

export const createBrand = async (payload) => {
    const res = await http.post("/brands/create", payload, {
        skipGlobalLoader: true
    });
    return res.data;
};

export async function deleteBrand(brandId) {
    const res = await fetch(process.env.REACT_APP_BACKEND_BASE_URL + "/api/v1/models/delete", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-source-system": "web",
        },
        body: JSON.stringify({
            brandId,
        }),
    });

    if (!res.ok) {
        let message = "Failed to delete brand";
        try {
            const err = await res.json();
            message = err.message || message;
        } catch {
            // ignore json parse error
        }
        throw new Error(message);
    }

    try {
        return await res.json();
    } catch {
        return { message: "Brand deleted successfully" };
    }
}

export async function updateBrand({ brandId, name }) {
    const res = await fetch(process.env.REACT_APP_BACKEND_BASE_URL + "/api/v1/models/update", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-source-system": "web",
        },
        body: JSON.stringify({
            brandId,
            name,
        }),
    });

    if (!res.ok) {
        let message = "Failed to update brand";
        try {
            const err = await res.json();
            message = err.message || message;
        } catch {
            // ignore parse error
        }
        throw new Error(message);
    }

    try {
        return await res.json();
    } catch {
        return { message: "Brand updated successfully" };
    }
}
